import { DICT_RIGHTS } from '@/common/rights.js';
import { deepFreeze } from '@dsee/util/objects.js';
import { checkSession } from '@/restapi/user/user.js';
import local from './util/local.js';

const CURRENT_USER_KEY = 'CURRENT_USER';
let cachedUser = prepareUser(local.get(CURRENT_USER_KEY, {}));


/**
 * "Подготовить" объект пользователя
 */
function prepareUser(source) {
    if (!source?.rights || !Array.isArray(source.rights))
        source.rights = [];

    return deepFreeze({
        ...source,
        rights: new Set(source?.rights ?? []),
    });
}


/**
 * Получить инфо по текущему пользователю
 */
export function currentUser() {
    return cachedUser;
}


/**
 * Обновить данные сессии
 */
export function updateSession(user) {
    local.put(CURRENT_USER_KEY, user);
    return (cachedUser = prepareUser(user));
}


/**
 * Получить актуальные данные о пользователе
 */
export async function getActual() {
    let temp;
    try {
        temp = await checkSession();
    } catch (e) {
        console.warn(e);
    }
    return updateSession(temp ?? {});
}



/**
 * Проверить наличие у польз-ля любого из перечисленных прав
 * @param rights[] список прав
 */
export function hasRights(rights) {
    if (rights.length === 0)
        return true;

    return anyInSet(rights, cachedUser.rights);
}

function anyInSet(array, set) {
    for (const value of array) {
        if (set.has(value))
            return true;
    }
    return false;
}


/**
 * Проверить наличие у польз-ля всех перечисленных прав
 * @param rights[] список прав
 */
export function hasAllRights(rights) {
    if (rights.length === 0)
        return true;

    return allInSet(rights, cachedUser.rights);
}

function allInSet(array, set) {
    for (const value of array) {
        if (!set.has(value))
            return false;
    }
    return true;
}


/**
 * Право на доступ к справочникам
 */
export function hasAnyDictRight() {
    const userRights = cachedUser.rights;
    return anyInSet(DICT_RIGHTS, userRights);
}

/**
 * Проверить наличие роли пользователя
 * @param roles[] список ролей
 */
export function hasRoles(roles) {
    if (!Array.isArray(roles))
        throw new TypeError('Parameter [2] is not an array');

    if (roles.length === 0)
        return true;

    const userRoles = cachedUser.roles;

    if (!userRoles)
        return false;

    return roles.some(role => userRoles.includes(role));
}
